import { ErrorOutline } from '@mui/icons-material';

type ActionNeededBadgeProps = {
  count: number;
};

/** Badge showing how many compliance actions remain for a resource. */
export const ActionNeededBadge = ({ count }: ActionNeededBadgeProps) => {
  if (count <= 0) {
    return null;
  }

  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-[#FFF4E5] px-2.5 py-0.5 font-open-sans text-[13px] font-medium text-[#B45309]">
      <ErrorOutline sx={{ fontSize: 14 }} />
      {count} action{count === 1 ? '' : 's'} needed
    </span>
  );
};

export default ActionNeededBadge;
